<template>
  <div
    class="con-select autocompletex"
    :class="{ 'w-100': block }"
  >
    <label :for="name" class="vs-select--label">{{ label }}</label>
    <div class="d-flex">
      <v-select
        :name="name"
        :value="optionSelected"
        :options="listOptions"
        :class="{ 'v-select-danger': danger, 'w-100': block }"
        :disabled="isDisabled"
        @input="onInput"
      >
        <template #spinner>
          <div
            v-if="officesState.loading"
            style="border-left-color: rgba(88,151,251,0.71)"
            :style="{ opacity: officesState.loading ? 1 : 0 }"
            class="vs__spinner"
          />
        </template>
        <template slot="no-options">
          no hay oficinas para el criterio de búsqueda
        </template>
      </v-select>
      <vs-icon
        v-if="withFilters && filters.length > 1"
        class="cursor-pointer ml-2"
        icon="delete"
        size="medium"
        v-tooltip="'Limpiar filtros'"
        color="danger"
        @click="cleanFilters"
      />
      <vs-icon
        v-if="withFilters"
        class="cursor-pointer ml-2"
        icon="filter_list"
        size="medium"
        v-tooltip="'Filtrar oficinas'"
        color="secondary"
        @click="$refs.officefilters.show()"
      />
    </div>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
    <b-modal
      ref="officefilters"
      v-if="withFilters"
      title="Filtros"
      centered
      no-close-on-backdrop
      hide-footer
      size="lg"
    >
      <OfficeFilters
        :currentFilters="filters"
        :clearCategory="clearCategory"
        :clearSubcategory="clearSubcategory"
        @category="regionId = $event"
        @subcategory="serviceId = $event"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import OfficeFilters from '@/febos/chile/lists/modals/OfficeFilters';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  components: { OfficeFilters },
  data() {
    return {
      regionId: null,
      serviceId: null,
      filters: [{ key: 'isOffice', filter: 'esOficina:Y' }]
    };
  },
  watch: {
    regionId(value) {
      if (!value) {
        this.fetchOffices(this.filters);
        return;
      }
      this.filters = this.filters.filter((obj) => obj.key !== 'regionId');
      this.filters.push({ key: 'regionId', filter: value });
      this.fetchOffices(this.filters);
    },
    serviceId(value) {
      if (!value) {
        this.fetchOffices(this.filters);
        return;
      }
      this.filters = this.filters.filter((obj) => obj.key !== 'serviceId');
      this.filters.push({ key: 'serviceId', filter: value });
      this.fetchOffices(this.filters);
    }
  },
  computed: {
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('List', [
      'officesState'
    ]),
    optionSelected() {
      return this.listOptions.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.listOptions.length
        || this.officesState.loading;
    },
    listOptions() {
      const officeType = (this.officeType === 'numOf' || this.officeType === 'ext')
        ? 'ext' : 'int';

      let offices = this.officesState.list;

      if (this.typeList === StepTypes.OFFICE
        || this.typeList === StepTypes.INTERNAL_OFFICES
        || this.typeList === StepTypes.EXTERNAL_OFFICES
      ) {
        offices = offices.filter((group) => group.type === officeType);
      }

      if (this.validateLider) {
        offices = offices
          .filter((office) => (
            (office.users > 1 && office.hasLead === 'Y')
              || (office.users === 1 && (office.hasLead === 'Y' || office.hasLead === 'N'))
          ));
      }

      if (offices.length === 1) {
        this.onInput(offices[0]);
      }

      return offices;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchOffices'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.officesState.list.find((option) => option.value === this.value);
    },
    clearCategory() {
      if (!this.regionId) return;
      this.filters = this.filters.filter((filter) => filter.key !== 'regionId');
      this.regionId = null;
    },
    clearSubcategory() {
      if (!this.serviceId) return;
      this.filters = this.filters.filter((filter) => filter.key !== 'serviceId');
      this.serviceId = null;
    },
    cleanFilters() {
      this.filters = [{ key: 'isOffice', filter: 'esOficina:Y' }];
      this.regionId = null;
      this.serviceId = null;
    }
  },
  created() {
    if (this.filterMyOffices) {
      this.filters.push({ key: 'usuarioId', filter: `usuarioId:${this.currentUser.id}` });
    }
    this.fetchOffices(this.filters);
  },
  props: {
    name: { type: String, required: true },
    withFilters: { type: Boolean, default: false },
    typeList: { type: Number },
    officeType: { type: String },
    filterMyOffices: { type: Boolean, default: false },
    label: { type: String, default: 'Dirección / Región' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    validateLider: { type: Boolean, default: false },
  }
};

</script>
